<template>
	<PopupRouterView :showLeftIcon="true" :label="labelHeader" okTitle="Save" cancelTitle="Cancel" entityName="putaway"
		:documentId="mainRecordId" @saveMethod="saveAction" @hideMethod="onHidden" ref="putAwayInput"
		modalClass="input-scan-page">

		<template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
				<b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

		<div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<app-input-datepicker id="fieldset-put-away-date" label-cols-lg="12" label="Date" size="sm"
							:model.sync="model.processDate" :isRequired="true" :state="validateState('processDate')"
							:errorMessage="getErrorMessage(errorMessage.processDate, 'processDate')"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
							locale="en-GB" />
						<app-input-radio :options="putawayCategorys" text-field="name" value-field="id"
							label-cols-lg="12" label="Putaway Category" id="fieldset-put-away-category"
							:model.sync="model.putawayCategoryId" />
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 2">
				<b-row>
					<b-col cols="6">
						<app-input-textbox id="fieldset-putaway-category-name" label-cols-sm="4" label-cols-lg="3" label="Putaway Category" label-for="fieldset-putaway-category-name" size="sm" :model.sync="model.putawayCategory.name" :isEditable="false" />
						<app-input-textbox id="fieldset-scanned-by-firstname" label-cols-sm="4" label-cols-lg="3" label="Process By" label-for="fieldset-scanned-by-firstname" size="sm" :model.sync="model.scannedByFirstName" :isEditable="false" />
					</b-col>
					<b-col cols="6">
						<app-input-textbox id="fieldset-total-scanned" label-cols-sm="4" label-cols-lg="3" label="Total Scanned" label-for="fieldset-total-scanned" size="sm" :model.sync="totalPutawayScanned" :isEditable="false" />
						<app-input-textbox id="fieldset-area-code" label-cols-sm="4" label-cols-lg="3" label="Source Area" label-for="fieldset-area-code" size="sm" :model.sync="model.areaId != null ? model.area.name : model.areaId" :isEditable="false" />
					</b-col>
					<b-col cols="12">
						<app-input-scan id="fieldset-control-card" ref="fieldset-control-card"
							:model.sync="controlCardQrCode" label="Control Card" @scannedMethod="scanControlCard(controlCardQrCode)"
							:isBusy="isScanControlCardLoading" />
					</b-col>
					<!-- <b-col cols="12">
						<app-list :isDataLoading="isControlCardsLoading" :dataCount="controlCards.length">
							<b-list-group-item>
								<div class="list-title" v-for="(item, index) in controlCards"
									@click="scanControlCard(item)">
									<b-row>
										<b-col cols="12">
											{{ item.controlCardNumber }}
											<hr />
										</b-col>
									</b-row>
								</div>
							</b-list-group-item>
						</app-list>
					</b-col> -->
					<b-col cols="12">
						<h5 class="card-title font-weight-bolder text-dark">Control card list</h5>
						<div id="container-table-putaway">
							<b-table id="table-input-putaway" head-variant="head-light" :bordered="true"
								:no-local-sorting="true" :items="putawayScanned"
								:fields="fieldsputaway" :busy="isDataLoading"
								:sort-by.sync="sortByPutAway"
								:sort-desc.sync="sortDescPutAway" small show-empty>
								<template v-slot:cell(front-action)="row">
									<b-button size="sm" @click="deleteDataPutaway(row.item.id)" class="mr-2 btn-xs btn-transparent btn-color-danger border-0">
										<b-icon-trash></b-icon-trash>
									</b-button>
								</template>
								<template v-slot:cell(no)="row">
									{{ (row.index + 1) }}
								</template>
								<template v-slot:cell(controlCard)="row">
									{{ row.item != null && row.item.controlCard != null ? row.item.controlCard.controlCardNumber : '' }}
								</template>
								<template v-slot:cell(area)="row">
									{{ row.item != null && row.item.controlCard != null && row.item.controlCard.area != null ? row.item.controlCard.area.name : '' }}
								</template>
							</b-table>
						</div>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 3">
				<b-row>
					<b-col cols="12">
						<app-label label-cols-lg="12" size="sm" label="Rack Suggestion"
							:model="(rackSuggestion != null) ? rackSuggestion.code : null"
							v-if="model.putawayCategory.name.toUpperCase() === 'MATERIAL RETURN'" />
						<app-input-scan id="fieldset-rack" ref="fieldset-rack" :model.sync="rackQrCode" label="Rack"
							@scannedMethod="scanRack" :isBusy="isScanRackLoading" :waitInputScan="waitInputScanRack"
							@clearMethod="clearMethodScanRack" />
						<app-label label-cols-lg="12" size="sm" label="Area" :model="rackScan.area.name"
							v-if="rackScan !=null && rackScan.area != null" />
						<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark"
							label-for="input-remark" size="sm" :model.sync="model.remark" @change="updateData" />
					</b-col>
						<b-col cols="12">
							<h5 class="card-title font-weight-bolder text-dark">Control card list</h5>
							<div id="container-table-putaway">
								<b-table id="table-input-putaway" head-variant="head-light" :bordered="true"
									:no-local-sorting="true" :items="putawayScanned"
									:fields="fieldsputaway" :busy="isDataLoading"
									:sort-by.sync="sortByPutAway"
									:sort-desc.sync="sortDescPutAway" small show-empty>
									<template v-slot:cell(front-action)="row">
										{{ (row.index + 1) }}
									</template>
									<template v-slot:cell(controlCard)="row">
										{{ row.item != null && row.item.controlCard != null ? row.item.controlCard.controlCardNumber : '' }}
									</template>
									<template v-slot:cell(area)="row">
										{{ row.item != null && row.item.controlCard != null && row.item.controlCard.area != null ? row.item.controlCard.area.name : '' }}
									</template>
								</b-table>
							</div>

						</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 4">
				<b-row>
					<b-col cols="12">
						<!-- <div class="custom-error-putaway"> -->
						<div class="alert alert-warning">
							Rack yang anda scan tidak sesuai dengan Rack Customer nya. Silahkan Scan Supervisor ID
							untuk
							melanjutkan.
						</div>
						<!-- </div> -->
						<app-input-scan id="fieldset-approval" ref="fieldset-approval" :model.sync="approvalQrCode"
							label="Approval" @scannedMethod="scanApproval" :isBusy="isScanApprovalLoading" />
					</b-col>
				</b-row>
			</span>

		</div>


		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-action-button>
			<b-button v-if="scanPageIndex == 1" size="sm" class="btn-fill-success float-right"
				@click="goToNext(2)">Next</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-danger float-right mr-1"
				@click="goToNext(1, modelId)">Back</b-button>
				<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-success float-right"
				@click="goToNext(3)">Next</b-button>
			<!-- <b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-success float-right"
				@click="goToNext(3)">Next</b-button> -->
			<b-button v-if="scanPageIndex == 3" size="sm"
				class="btn-fill-danger float-right" @click="goToNext(2)">Back</b-button>
			<b-button v-if="scanPageIndex == 3" size="sm" class="btn-fill-success float-right"
				@click="saveAction()">Finish</b-button>
			<b-button v-if="scanPageIndex == 4" size="sm" class="btn-fill-success float-right mr-1"
				@click="$router.back()">Close</b-button>

		</template>

	</PopupRouterView>
</template>
<style scoped>
#container-table-putaway {
	height: 200px;
	overflow-y: scroll;
	width: 100%;
	overflow-x: scroll;
}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScanFadly';
import AppList from '@/components/AppList';
import PutAway from '@/models/PutAway/PutAway';
import PutAwayList from '@/models/PutAway/PutAwayList';
import PutAwayFilter from '@/filters/PutAway/PutAwayFilter';
import PutAwayHeader from '@/models/PutawayHeader/PutawayHeader';
import PutAwayHeaderFilter from '@/filters/PutawayHeader/PutawayHeaderFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputRadio from '@/components/AppInputRadio';
import PutAwayCategory from '@/models/PutAwayCategory/PutAwayCategory';
import PutAwayCategoryFilter from '@/filters/PutAwayCategory/PutAwayCategoryFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppLabel from '@/components/AppLabel';
import Rack from '@/models/Rack/Rack';
import RackFilter from '@/filters/Rack/RackFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import PopupRouterView from '@/components/PopupRouterView';
import ControlCardLog from '@/models/ControlCardLog/ControlCardLog';
import ControlCardLogFilter from '@/filters/ControlCardLog/ControlCardLogFilter';
import VwControlCardForPostingPutaway from '@/models/VwControlCardForPostingPutaway/VwControlCardForPostingPutaway';
import VwControlCardForPostingPutawayFilter from '@/filters/VwControlCardForPostingPutaway/VwControlCardForPostingPutawayFilter';
import AppInputTextbox from '@/components/AppInputTextbox';

export default {
	components: {
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputRadio,
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputTextarea,
		PopupRouterView,
		AppInputScan,
		AppList,
		AppInputTextbox,
	},
	mixins: [validationMixin, toast, focusInput],
	validations: {
		model: {
			processDate: { required },
		},
	},
	data() {
		return {
			errorMessage: {
				processDate: { required: "Date is Required." },
			},
			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			busy: false,
			isBusy: false,
			isDataLoading: false,
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterPutAway: null,
			currentPutAwayPage: 1,
			putAwayPageSize: 10,
			sortByPutAway: '',
			sortDescPutAway: '',
			putawayCategorys: [],
			isPutAwayCategoryComboLoading: false,
			controlCards: [],
			controlCards: [],
			isControlCardComboLoading: false,
			racks: [],
			racks: [],
			isRackComboLoading: false,
			userInfos: [],
			approvals: [],
			isApprovalComboLoading: false,
			isShowPopupConfirmation: false,
			isDataCommited: false,
			mainRecordId: '',
			isPutAwayCategoryComboLoading: false,
			isControlCardComboLoading: false,
			isRackComboLoading: false,
			isUserInfoComboLoading: false,
			scanPageIndex: 1,
			controlCardQrCode: '',
			isScanControlCardLoading: false,
			rackQrCode: '',
			rackScan: {},
			isScanRackLoading: false,
			approvalQrCode: '',
			isScanApprovalLoading: false,
			labelHeader: 'Putaway',
			isControlCardsLoading: false,
			rackSuggestion: {},
			isLockFromRack: false,
			isScanRack: false,
			waitInputScanRack: false,
			putawayScanned: {},
			totalPutawayScanned: 0,
			isProcessScan: false,
			oldCategoryId: 0,
			fieldsputaway: [
				{ "front-action": { "class": "th-front-action", "label": "" } },
				{ "controlCard": {}, "class": "th-control-card last-child", "label": "Control Card Number", key: 'controlCard', sortable: false },
				//{ "controlCardNumber": {}, "class": "th-control-card-number d-stack-none", "label": "Control Card Number", key: 'controlCardNumber', sortable: true },
				{ "area": {}, "class": "th-rack d-stack-none", "label": "Area", key: 'area', sortable: false },
				// { "approval": {}, "class": "th-approval d-stack-none", "label": "Approval", key: 'approval', sortable: true },
				// { "isLocked": {}, "class": "th-is-locked d-stack-none", "label": "IsLocked", key: 'isLocked', sortable: true },
			],
		}
	},
	methods: {
		refreshData() {
			this.model.documentStatusId = 'OPEN';
			this.model.areaId = null;	
			this.model.area = null;
			this.model.customerId = null;
			this.updateData();	
		},
		deleteDataPutaway(id) {
			return PutAway.deleteData(this, id).then(async result => {
				if (result) {
					await this.getPutAways(this.modelId);
					if(this.totalPutawayScanned < 1)
					{
						this.refreshData();
					}
				}
			})
		},
		clearMethodScanRack() {
			this.rackScan = null;
			this.rackQrCode = '';
			this.isScanRack = false;
			this.setSelectedRack(null);
			this.waitInputScanRack = false;
		},
		getSuggestionRack: async function () {
			let filter = new RackFilter();
			if(this.model.areaId != null && this.model.customerId !=null)
			{
				filter.areaId = this.model.areaId;	
			}

			const response = await this.$http.get(`PutAway/getRackSuggestion/${this.model.id}`);
			if(response && response.data) {
				this.rackSuggestion = response.data;
			}

			// Rack.getList(this, filter, null, 0, 1).then(result => {
			// 	this.rackSuggestion = result.data[0];
			// })
		},
		checkPutawayLocked: async function (id) {
			PutAway.checkputawaylocked(this).then(result => {
				if (result == true) {
					this.getPutAway(id);
					return;
				}

				this.goToNext(4);
			})
		},
		checkPutaway: async function (id) {
			this.getPutAway(id).then(result => {
				if (result != null && result.isLocked == true) {
					this.goToNext(4)
					return;
				}
				if (result.approvalUserName != null) {
					this.goToNext(3, result.controlCard);
					return;
				}
			})
		},
		getPutAwayHeader: async function (id) {
			this.isBusy = true;
			return await PutAwayHeader.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);

				this.getPutAways(result.id).then(res => {
					let data = this.putawayScanned.find(item => item.approvalUserName != null);
					if(this.putawayScanned.some(item => item.isLocked == true)) {
						this.goToNext(4);
					} else if(data != null || this.isScanRack == true) {
						this.goToNext(3);
						if(this.isScanRack == false) {
							this.isLockFromRack = true;
						}
					}else if(this.model.documentStatusId == "IN_PROGRESS")
					{
						this.goToNext(2);
					} else if(this.model.documentStatusId == "OPEN" && this.oldCategoryId == this.model.putawayCategoryId)
					{
						this.goToNext(1);
					}
					this.oldCategoryId = result.putawayCategoryId;

				})
				// let promises = Array();
				// if (this.model.controlCardId != null) {
				// 	promises.push(
				// 		this.getControlCard(this.model.controlCardId).then(result => {
				// 			return true;
				// 		}).catch(error => {
				// 			this.$store.dispatch('addErrorMessageGlobal', error);
				// 			throw error;
				// 		})
				// 	);
				// }
				// if (this.model.isLocked == true && this.scanPageIndex == 3) {
				// 	this.isLockFromRack = true;
				// 	this.goToNext(4);
				// } else if (this.model.isLocked == true) {
				// 	this.goToNext(4);
				// }
				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
				return this.model;
			}).catch(error => { this.isBusy = false; });
		},
		// getPutAway: async function (id) {
		// 	this.isBusy = true;
		// 	return await PutAway.getData(this, id).then(result => {
		// 		this.model = result;
		// 		this.model.putAwayDate = new Date();
		// 		this.mainRecordId = String(result.mainRecordId);
		// 		let promises = Array();
		// 		if (this.model.controlCardId != null) {
		// 			promises.push(
		// 				this.getControlCard(this.model.controlCardId).then(result => {
		// 					return true;
		// 				}).catch(error => {
		// 					this.$store.dispatch('addErrorMessageGlobal', error);
		// 					throw error;
		// 				})
		// 			);
		// 		}
		// 		if (this.model.isLocked == true && this.scanPageIndex == 3) {
		// 			this.isLockFromRack = true;
		// 			this.goToNext(4);
		// 		} else if (this.model.isLocked == true) {
		// 			this.goToNext(4);
		// 		}
		// 		Promise.all(promises).then((results) => {
		// 			this.isBusy = false;
		// 		});
		// 		return this.model;
		// 	}).catch(error => { this.isBusy = false; });
		// },
		getPutAwayCategory: async function (id) {
			this.isBusy = true;
			try {
				this.model.putawayCategory = await PutAwayCategory.getData(this, id);
				this.isBusy = false;
			}
			catch {
				this.isBusy = false;
			}
			return this.model.putawayCategory;
		},
		downloadData() {
			this.isDownloadPutAway = true;
			this.filterPutAway.id = this.modelId;
			PutAway.downloadDataDetail(this, this.filterPutAway).then(result => {
				this.isDownloadPutAway = false;
			}).catch(error => { this.isDownloadPutAway = false; })
		},
		getPutAways: async function (parentId) {
			let filter = new PutAwayFilter();
			if (parentId != undefined) {
				filter.PutawayHeaderId = parentId;
			}
			filter.draftMode = 1;
			this.isPutAwayComboLoading = true;
			return await PutAway.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.totalPutawayScanned = result.dataCount;
						this.putawayScanned = result.data;
					}
					this.isPutAwayComboLoading = false;
					return result;
				})
				.catch(error => { });
		},
		getPutAwayCategorys: async function (input) {
			let filter = new PutAwayCategoryFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await PutAwayCategory.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.putawayCategorys = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedPutAwayCategory(item) {
			if (item == undefined || item == null) {
				this.model.putawayCategoryId = null;
				this.model.putawayCategory = null;
			} else {
				this.model.putawayCategoryId = item.id;
				this.model.putawayCategory = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getControlCards: async function (input) {
			this.isControlCardsLoading = true;
			let filter = new ControlCardFilter();
			filter.controlCardStatusId = 'OK,POSTED';
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			if (this.model.putawayCategory != undefined && this.model.putawayCategory.name.toUpperCase() === 'POSTING') {
				var filterVw = new VwControlCardForPostingPutawayFilter();
				// filterVw.statusId = 'APPROVED';
				// filterVw.isDraft = 0;
				if (input != undefined) {
					filterVw.controlCardNumber = input;
				}

				await VwControlCardForPostingPutaway.getListVw(this, filterVw, null, 0, 5)
					.then(result => {
						if (result != null) {
							this.controlCards = result.data
						}
						this.isControlCardsLoading = false;
					})
					.catch(error => { this.isControlCardsLoading = false; });
			} else {
				filter.readyForPutaway = true;
				await ControlCard.getList(this, filter, null, 0, 5)
					.then(result => {
						if (result != null) {
							this.controlCards = result.data
						}
						this.isControlCardsLoading = false;
					})
					.catch(error => { this.isControlCardsLoading = false; });
			}
		},
		setSelectedControlCard(item) {
			if (item == undefined || item == null) {
				this.model.controlCardId = null;
				this.model.controlCard = null;
			} else {
				this.model.controlCardId = item.id;
				this.model.controlCard = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getRacks: async function (input) {
			let filter = new RackFilter();
			if (input != undefined) {
				filter.code = input;
			}
			await Rack.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.racks = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedRack(item) {
			if (item == undefined || item == null) {
				this.model.rackId = null;
				this.model.rack = null;
			} else {
				this.model.rackId = item.id;
				this.model.rack = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getUserInfos: async function (input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			await UserInfo.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.userInfos = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedApproval(item) {
			if (item == undefined || item == null) {
				this.model.approvalUserName = null;
				this.model.approval = null;
			} else {
				this.model.approvalUserName = item.userName;
				this.model.approval = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getControlCard: async function (id) {
			ControlCard.getData(this, id).then(result => {
				this.model.controlCard = result;
				this.isBusy = false;
				return result;
			}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.putAwayInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			if (modalEvent != undefined && modalEvent != null) {
				modalEvent.preventDefault();
			}
			if (this.rackQrCode == null && this.rackScan == null) {
				this.toast({ message: 'Rack is required', title: 'Error', variant: 'danger' });
				return;
			}
			this.rackQrCode = this.rackScan == null ? this.rackScan.code : this.rackQrCode;
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch();
			let this_ = this;
			if (this_.$v.model.$anyError) {
				return;
			} else {
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				this_.isBusy = true;
				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						PutAwayHeader.finishScan(this, model, id).then(result => {
							if (result != null) {
								this.$router.replace('/putaway/scan/' + result.id, () => {
									result.putawayCategoryId = this.model.putawayCategoryId;
									result.putawayCategory = this.model.putawayCategory;
									// result.processDate = new Date();
									this.setModel(result);
									return;
								});
								this.goToNext(2, this.model);
								this_.isBusy = false;
							}
						}).catch(function (error) {
							this_.isBusy = false;
							throw error;
						});
					} else {
						PutAway.insertData(this, model).then(result => {
							this_.isDataCommited = true;
							if (result) {
								this_.$router.push({ name: 'putawayindex' });
							}
							this_.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		setModel(model) {
			this.modelId = model.id;
			this.model = model;
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					return PutAwayHeader.updateData(this, model, id)
						.catch((error) => {
							return this.getPutAwayHeader(id);
						});
				}
				return false;
			});
		},
		onHidden() {
			this.getPutAways();
		},
		resetModal(modalCategory) {
			this.controlCardQrCode = '';
			this.rackQrCode = '';
			this.approvalQrCode = '';
			this.showPopupCopyData = false;
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
			}
		},
		scanControlCard() {
			let qrCode = decodeURIComponent(this.controlCardQrCode);
			let id = this.model.id;
			let this_ = this;
			this_.isBusy = true;
			return PutAwayHeader.scanControlCard(this_, id, qrCode, this.model.putawayCategoryId)
				.then(async response => {
					this_.getPutAwayHeader(id);
					await this_.getPutAways(id);
					this_.controlCardQrCode = '';
					this_.toast({ message: 'Scan Control Card berhasil', title: 'Alert', variant: 'success',autoHideDelay: 2000 });
					this_.isBusy = false;
					return response;
				}).catch(function (error) {
					this_.controlCardQrCode = '';
					this_.isBusy = false;
					throw error;
				});
		},
		scanRack() {
			let qrCode = encodeURIComponent(this.rackQrCode);
			let id = this.model.id;
			let this_ = this;
			this_.isBusy = true;
			PutAwayHeader.scanRack(this_, id, qrCode)
				.then(async function (result) {
					if (result != null) {
						this_.model.rack = result;
						this_.model.rackId = result.id;
						this_.rackScan = result;
						this_.isBusy = false;
						this_.waitInputScanRack = true;
						this_.toast({ message: 'Scan Rack berhasil', title: 'Alert', variant: 'success' });
						return;
					}
				})
				.catch(async function (error) {
					this_.rackQrCode = null;
					this_.rackScan = null;
					this_.waitInputScanRack = false;
					this_.isScanRack = true;
					await this_.getPutAwayHeader(id);
					//this_.model.rack = null;
					//this_.model.rackId = null;
					this_.isBusy = false;
					//this_.$store.dispatch('addErrorMessageGlobal', error);
					throw error;
				});
		},
		async scanApproval() {
			let qrCode = encodeURIComponent(this.approvalQrCode);
			let id = this.modelId;
			let this_ = this;
			this_.isBusy = true;
			// lanjut sini
			try {
				let result = await PutAway.scanApproval(this_, id, qrCode);
				// let result = await this.$http.get('PutAway/ScanApproval?id=' + id + '&qrcode=' + qrCode)
				// 	.then(function (response) {
				// 		this_.isBusy = false;
				// 		this_.model.approvalUserName = qrCode;
				// 		return response.data;
				// 	})
				// 	.catch(function (error) {
				// 		this_.isBusy = false;
				// 		this_.$store.dispatch('addErrorMessageGlobal', error);
				// 		throw error;
				// 	});

				if (result == true) {
					this_.getPutAwayHeader(id);
					this_.approvalQrCode = "";
					this_.isBusy = false;
					this_.isLockFromRack = true;
					// if (this.isLockFromRack == true) {
					// 	this.isLockFromRack = false;
					// 	this.goToNext(3);
					// 	return;
					// }
					// this.model.isLocked = false;
					// this.goToNext(1, id);
					//this.$router.back();
				}
			} catch { this.isBusy = false; }
		},
		checkAndDeletePutaway()
		{
			if(this.model.putawayCategoryId != this.oldCategoryId) {
				this.$store.dispatch('addCheckAllData', this.putawayScanned.map(item=>item.id));
				let data = this.$store.state.dataIds;
				if (data.length > 0) {
					PutAway.deleteMultipleData(this).then(async result => {
						// console.log("bfr get putaway")
						await this.getPutAwayHeader(this.modelId);
						// console.log("aft get putaway")
						// this.goToNext(2);
					}).catch(error => {  });
				}
				this.refreshData();
			}
			//this.oldCategoryId = this.model.putawayCategoryId;
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				PutAway.deleteMultipleData(this).then(result => {
					this.getPutAways();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		async goToNext(page, item) {
			if (page == 1) {
				//this.getPutAwayHeader(item);
				this.scanPageIndex = page;
				return;
			}
			if (page == 2) {
				if (this.model.putawayCategoryId == null || this.model.putawayCategoryId == "") {
					this.toast({ message: 'Putaway Category is required', title: 'Error', variant: 'danger' });
					return;
				}
				this.clearMethodScanRack();
				this.setSelectedRack(null);
				// this.updateData();
				this.model.putawayCategory = await this.getPutAwayCategory(this.model.putawayCategoryId);
				this.checkAndDeletePutaway();

				this.labelHeader = "Control Card";
				this.getControlCards();
				await this.getPutAways(this.modelId);
				this.scanPageIndex = page;
				this.$nextTick(() => {
					this.focusInput(this, 'fieldset-control-card');
				});
				return;
			}
			if (page == 3) {
				// if (this.model.isLocked == true) {
				// 	this.getControlCardLogs();
				// 	this.scanPageIndex = page;
				// 	return;
				// }
				if(this.totalPutawayScanned <= 0)
				{
					this.toast({ message: "Scan Control card terlebih dahulu", title: 'Error', variant: 'danger' });
					return;
				}
				var result = this.putawayScanned.find(p=>p.rackId !=null);
				if(result == null) {
					result = this.putawayScanned[0].controlCard
				} else {
					this.rackScan = this.rackQrCode ? this.rackQrCode : result.rack;
					this.rackQrCode = result.rack != null ? result.rack.code : null;
					if(this.rackQrCode != null)
					{
						this.waitInputScanRack = true;
					}
					result = result.controlCard;
				}
				
				if (this.isLockFromRack == false && this.rackScan == null && (this.model.putawayCategory != undefined && this.model.putawayCategory.name.toUpperCase() == 'POSTING'
						&& ((result.qcStatusId == null || result.qcStatusId == undefined)
							|| (result.areaCode == "INCOMING_FG")))) {
						const msg = this.$createElement;
						const msgNode = msg('div', {
							domProps: {
								innerHTML: `<p>Control card belum di QC.</p><p>Apakah anda ingin melanjutkan Posting Control Card?</p>`
							}
						});
						this.$bvModal.msgBoxConfirm([msgNode], {
							title: 'Confirmation',
							size: 'sm',
							buttonSize: 'sm',
							okVariant: 'success',
							cancelVariant: 'danger',
							okTitle: 'Yes',
							cancelTitle: 'No',
							footerClass: 'p-2',
							hideHeaderClose: false,
							centered: true
						})
							.then(value => {
								if (value) {
									this.focusInput(this, 'fieldset-rack');
									// this.setSelectedControlCard(result);
									this.isProcessScan = false;
									this.scanPageIndex = page;
								}
							})
							.catch(err => { });
						return;
					} else if(this.model.putawayCategory.name.toUpperCase() === 'MATERIAL RETURN'){
						this.getSuggestionRack();
					}
					this.focusInput(this, 'fieldset-rack');
					this.isProcessScan = false;
					// this.setSelectedControlCard(result);

					this.scanPageIndex = page;
				return;
			}
			if (page == 4) {
				this.isBusy = true;
				this.focusInput(this, 'fieldset-approval');
				this.scanPageIndex = page;
				this.isBusy = false;
			}
		},
	},
	beforeMount() {
		this.filterPutAway = new PutAwayFilter();
		this.getPutAwayCategorys();
		//this.getControlCards();
		//this.getRacks();
		//this.getUserInfos();
	},
	async mounted() {
		let id = this.$route.params.id;
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			//this.getPutAway(id);
			// this.checkPutaway(id);
			await this.getPutAwayHeader(this.modelId);
		}
		this.$nextTick(() => {

			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch: {
		// controlCardQrCode(newValue) {
		// 	this.getControlCards(newValue)
		// },
		scanPageIndex() {
			this.hideToast();
		}
	},
}
</script>
